import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { px2rem } from '@moim/common';
import { Link } from '../../components/link.mjs';
import styled, { css } from 'styled-components';
import { v4 } from 'uuid';
import * as React from 'react';
import { withPlacement } from '../../hoc/withPlacement.mjs';

var ImageContainer = styled.div.withConfig({
  displayName: "ImageContainer",
  componentId: "sc-1i5n444-0"
})(["& > img{object-fit:cover;}", ""], function (props) {
  var _a, _b, _c;
  if (props.ratio) {
    var rW = parseInt(props.ratio.split(":")[0], 10);
    var rH = parseInt(props.ratio.split(":")[1], 10);
    return css(["position:relative;width:100%;height:0;padding-top:", "%;& > img{width:100%;position:absolute;top:0;left:0;bottom:0;right:0;", ";", ";", ";}"], (100 * (rH / rW)).toFixed(2), ((_a = props.border) === null || _a === void 0 ? void 0 : _a.radius) ? css(["border-radius:", ";"], px2rem(props.border.radius)) : undefined, ((_b = props.border) === null || _b === void 0 ? void 0 : _b.thickness) ? css(["border-width:", ";"], px2rem(props.border.thickness)) : undefined, ((_c = props.border) === null || _c === void 0 ? void 0 : _c.color) ? css(["border-color:", ";"], props.theme.getColorByAlias(props.border.color)) : undefined);
  } else {
    return css(["width:100%;height:100%;& > img{width:100%;}"]);
  }
});
var StyledWithCarouselLink = styled(Link).withConfig({
  displayName: "StyledWithCarouselLink",
  componentId: "sc-1i5n444-1"
})(["width:100%;"]);
var ImageBlock = function ImageBlock(_a) {
  var _b;
  var onClick = _a.onClick,
    imageProps = _a.imageProps,
    block = __rest(_a, ["onClick", "imageProps"]);
  var src = block.src,
    ratio = block.ratio,
    border = block.border,
    fallbackSrc = block.fallbackSrc,
    href = block.href;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isError = _React$useState2[0],
    setError = _React$useState2[1];
  var _React$useState3 = React.useState(v4()),
    _React$useState4 = _slicedToArray(_React$useState3, 1);
    _React$useState4[0];
  var handleClick = React.useCallback(function (e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e, block);
  }, [href, block]);
  var currentSrc = React.useMemo(function () {
    if (isError && fallbackSrc) {
      return fallbackSrc;
    }
    return src;
  }, [fallbackSrc, isError, src]);
  var handleError = React.useCallback(function () {
    setError(true);
  }, []);
  return jsx(StyledWithCarouselLink, {
    href: href,
    children: jsx(ImageContainer, {
      ratio: ratio,
      border: border,
      children: jsx("img", Object.assign({
        role: onClick ? "button" : undefined,
        alt: (_b = currentSrc.split("/").pop()) !== null && _b !== void 0 ? _b : "",
        src: currentSrc,
        width: "100%",
        height: "100%",
        loading: "lazy",
        onError: handleError,
        onClick: handleClick
      }, imageProps))
    })
  });
};
var index = withPlacement(ImageBlock);

export { index as default };
